import ViewNextSongBtn from './ViewNextSongBtn';

export default ViewNextSongBtn;
